import { LayoutDashboard, Building2, FileText, Calendar, CalendarDays, Receipt, Users } from "lucide-react";
import { NavRoute } from "models/routes";

export const navRoutes = [
	{
		to: "/",
		title: "Dashboard",
		icon: LayoutDashboard,
	},
	{
		to: "/properties",
		title: "Properties",
		icon: Building2,
	},
	{
		to: "/reservations",
		title: "Reservations",
		icon: Calendar,
	},
	{
		to: "/calendar",
		title: "Calendar",
		icon: CalendarDays,
	},
	{
		to: "/guests",
		title: "Guests",
		icon: Users,
	},
	{
		to: "/statements",
		title: "Statements",
		icon: FileText,
	},
	{
		to: "/expenses",
		title: "Expenses",
		icon: Receipt,
	},
] as Array<NavRoute>;
